import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCalendar3: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="calendar-3, date"><path d="M3.75 4.75H20.25V20.25H3.75V4.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M7.75 4.75V2.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M16.25 4.75V2.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M7.75 8.75H16.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconCalendar3;
